/**
 *
 */


class CheckBox_Fuku {


	constructor(or34, resultNb) {

		this._or34 = or34;
		this._size = 10;
		this._max = 7;
		this._checkBox = new CheckBoxController( this._size, this._max, true);

		this._resultNb = resultNb;
		this._newResultNb = resultNb[resultNb.length-1];

		this._newResultNbNotDup = this._setNewResultNbNotDup(this._newResultNb);

	};

	get boxBooArr() {   return this._checkBox.boxBooArr;   }

	getIndexBoo(index) {
		return this._checkBox.boxBooArr[index];
	};

	get bit() {   return this._checkBox.bit;   };

	getTrueNumerArray() {
		return this._checkBox.getTrueNumerArray();
	};


	_setNewResultNbNotDup(rtNb) {
		let resultArr = [];
		for(let i=0, n=rtNb.length; i<n; i++) {
			let boo = true;
			for(let j=0, m=resultArr.length; j<m; j++) {
				if(rtNb[i]===resultArr[j]) {   boo = false;   }
			};
			if(boo) {   resultArr.push(rtNb[i]);   }
		};
		return resultArr;
	};


	userCustomObjList() {

		let objList = [];
		let obj = this.makeUserCustomObj( this._checkBox.getTrueNumerArray() );

		if( obj ) {   objList.push( obj );   };
		return objList;

	};



	setStateObj(obj) {

		let bit = obj.bit2;
		this._checkBox.boxBooArr = this._bitToArray(bit, 10);
	}


	userCustomStateObj() {

		return this.makeUserCustomObj( this._checkBox.getTrueNumerArray() );
	}



	makeUserCustomObj(bit2Arr) {

		let boo = bit2Arr.length===0 ? false : true;

		if( boo ) {

			let obj = {};
			obj.or34 = this._or34;
			obj.pls = 0;
			let bit1Arr = [0,1,1,1];
			if(this._or34===4) {   bit1Arr = [0,1,1,1,1];   };

			obj.bit1 = MyUtility.arrayToBit( bit1Arr );
			obj.cag = bit2Arr.length;

			let bit2 = 0;
			for(let i=0, n=bit2Arr.length; i<n; i++) {   bit2 += Math.pow( 2, bit2Arr[i] );   };
			obj.bit2 = bit2;

			return obj;

		}else {

			return null;
		};
	};


	click(index) {

		this._checkBox.click(index);
	};


	clear() {

		if(this._checkBox.getTrueNumerArray().length>0) {
			this._checkBox.clear();
		}else {
			for(let i=0, n=this._newResultNbNotDup.length; i<n; i++) {
				this.click( this._newResultNbNotDup[i] );
			};
		};
	};

	bindArray(booArray) {

		this._checkBox.bindArray(booArray);
	};



	_bitToArray(bit, size) {
		let booArr = new Array(size);
		for(let i=0; i<size; i++) {
			if( (Math.pow(2,i) & bit) > 0 ) {
				booArr[i] = true;
			}else {
				booArr[i] = false;
			};
		};
		return booArr;
	};




}